module.exports = __webpack_public_path__ + "static/media/add_upi_icon.93e132a6.svg";